import config from '../../config/index';
import TransactionWiseReportDownload from '../../models/TenantReports/MemberWiseReport';
import moment from 'moment';

export const getMemberLoyaltyReport = (filters: any) => {
  return fetch(
    `${config.ruleServerUrl}/users/reports/download/member_loyalty_report/${
      filters.businessId
    }?startDate=${moment(filters.startDate).format('YYYY-MMM-DD')}
    `,
    {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-type': 'application/json'
      }
    }
  ).then(r => r.json());
};

export const getMemberLoyaltyReportDownload = ({
  page,
  offset
}: {
  page: number;
  offset: number;
}): Promise<TransactionWiseReportDownload[]> => {
  return fetch(
    `${config.ruleServerUrl}/users/reports/view/downloads/member_loyalty_report?offset=${offset}&page=${page}`,
    { credentials: 'include' }
  ).then(res => res.json());
};
